<template>
  <div>
    <b-row>
      <b-col md="4">
        <b-form-group
                  id="fieldset-1"
                  label="Membership Type"
                  class="font-weight-bold"
                  label-for="input-1"
                >
                  <b-form-select
                    v-model="membership_types"
                    name="membership_types"
                    v-validate="'required'"
                    data-vv-as="Membership Type"
                    class="mb-3"
                  >
                    <template v-slot:first>
                      <option value disabled>-- Membership Type --</option>
                    </template>
                    <option value="all_type">All Type</option>
                    <option value="gold">Gold</option>
                    <option value="silver">Silver</option>
                  </b-form-select>
                  <p
                class="text-danger"
                style="width:100%;margin-top:.25rem;font-size: 80%;"
              >{{ veeErrors.first('membership_types') }}</p>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-form-group
            id="input-group-1"
            class="required"
            label-class="control-label"
            label="Image"
            label-for="input-1"
          ></b-form-group>
        <b-card class="text-center bg-gray-100" style="border-style: dashed;">
          <b-row v-if="veeErrors.first('image')" class="m-lg-1" style="background-color: #FEE8E9; border: 1px solid #ffc4c6; border-radius: 5px;margin-bottom: 20px !important;">
            <b-col md="12" id="img-error-report">
              <div style="width: 0%; text-align: center; vertical-align: middle; text-align:center;">
                <img src="@/assets/ic-warning-red.svg" class="ic_warning" style="width:25px; position:absolute; margin:auto; top:0; bottom:0;">
              </div>
              <div style="width: 97%; padding-left: 3%;">
                <ul class="text-left" style="margin: 7px 0px;">
                  <li class="text-danger" v-for="imageErr in veeErrors.collect('image')" :key="imageErr"><span class="text-dark">{{ imageErr }}</span></li>
                </ul>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <img v-if="url" width="100%" height :src="url" />
              <img v-else width="25%" style="margin-top: -14px;" height src="@/assets/image_not_found.png" />
            </b-col>
          </b-row>
          <input
            type="file"
            ref="file"
            style="display: none"
            name="image"
            v-validate="'required|minimalDimensions:1000,500|ratiolDimensions:2,1|size:2000|ext:jpg,png,gif,jpeg'"
            @change="onChangeFileUpload()"
          />
          <br />
          <b-link
            @click="$refs.file.click()"
            v-show="!file"
            variant="primary"
            class="text-primary btn"
          >
            <img class="mr-2" src="@/assets/ic-plus.svg" alt /> Select Image Here
            <label class="text-danger">*</label>
          </b-link>
          <b-button @click="$refs.file.click()" v-show="file" variant="outline-primary" class>
            <img class="mr-2" src="@/assets/ic-edit.svg" alt /> Edit
          </b-button>
          <br />
          <!-- <p
            class="text-danger"
            style="width:100%;margin-top:.25rem;font-size: 80%;"
          >{{ veeErrors.first('image') }}</p> -->
          <p
            class="text-gray-500"
          >Attach an image (the file must be at least 1000x500 pixels and maximum 2MB. Image must be in JPEG, PNG, or GIF format)</p>
          
        </b-card>
        <br>
        
        <br />
        <label class="text-danger">
          *
          <b class="text-dark">Required</b>
        </label>
      </b-col>

      <b-col md="8">
        <b-row>
          <b-col>
            <b-form-group
              id="input-group-1"
              class="required"
              label-class="control-label"
              label="Title Bahasa"
              label-for="input-1"
            >
              <input
                id="input-1"
                type="text"
                class="form-control"
                v-validate="'required'"
                name="title_id"
                data-vv-as="Title Bahasa"
                v-model="title_id"
                placeholder="Title Bahasa"
              />
              <b-form-invalid-feedback
                id="input-title_id-feedback"
              >{{ veeErrors.first('title_id') }}</b-form-invalid-feedback>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group
              id="input-group-1"
              class="required"
              label-class="control-label"
              label="Title English"
              label-for="input-1"
            >
              <input
                id="input-1"
                type="text"
                class="form-control"
                v-validate="'required'"
                name="title_en"
                data-vv-as="Title English"
                v-model="title_en"
                placeholder="Title English"
              />
              <b-form-invalid-feedback
                id="input-title_en-feedback"
              >{{ veeErrors.first('title_en') }}</b-form-invalid-feedback>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6">
            <b-form-group
              id="input-group-1"
              class="required"
              label-class="control-label"
              label="Content Bahasa"
              label-for="input-1"
            >
              <summer-note v-model="content_id" name="content_id_news" placeholder="Content Bahasa"></summer-note>
              <input type="hidden" v-model="content_id" v-validate="'required'" name="content_id" data-vv-as="Content Bahasa">
              <p
                class="text-danger"
                style="width:100%;margin-top:.25rem;font-size: 80%;"
              >{{ veeErrors.first('content_id') }}</p>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group
              id="input-group-1"
              class="required"
              label-class="control-label"
              label="Content English"
              label-for="input-1"
            >
              <summer-note v-model="content_en" name="content_en_news" placeholder="Content English"></summer-note>
              <input type="hidden" v-model="content_en" v-validate="'required'" name="content_en" data-vv-as="Content English">
              <p
                class="text-danger"
                style="width:100%;margin-top:.25rem;font-size: 80%;"
              >{{ veeErrors.first('content_en') }}</p>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6">
            <b-form-group
              id="input-group-1"
              label-class="control-label"
              label="PIC"
              label-for="input-1"
            >
              <input
                id="input-1"
                type="text"
                class="form-control"
                name="pic_name"
                data-vv-as="PIC"
                v-model="pic_name"
                placeholder="PIC"
              />
              <b-form-invalid-feedback
                id="input-pic_name-feedback"
              >{{ veeErrors.first('pic_name') }}</b-form-invalid-feedback>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6">
            <b-form-group
              id="input-group-1"
              label-class="control-label"
              label="No Contact"
              label-for="input-1"
            >
              <input
                id="input-1"
                type="text"
                class="form-control"
                name="pic_contact"
                data-vv-as="No Contact"
                v-model="pic_contact"
                placeholder="No Contact"
              />
              <b-form-invalid-feedback
                id="input-pic_contact-feedback"
              >{{ veeErrors.first('pic_contact') }}</b-form-invalid-feedback>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6">
            <b-form-group
              id="input-group-1"
              label-class="control-label"
              label="Url Link"
              label-for="input-1"
            >
              <input
                id="input-1"
                type="text"
                class="form-control"
                name="link_url"
                data-vv-as="Url Link"
                v-model="link_url"
                placeholder="Url Link"
              />
              <b-form-invalid-feedback
                id="input-link_url-feedback"
              >{{ veeErrors.first('link_url') }}</b-form-invalid-feedback>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6">
            <b-form-group id="fieldset-1" label="Event Date & Time" label-for="input-1">
              <b-row class="m-0">
                <b-col class="pr-0 pt-1 form-control img-calender-select border-right-0" md="2">
                  <img src="@/assets/ic-calendar-copy-30.svg" width="15px" alt class />
                </b-col>
                <b-col class="px-0">
                  <vc-date-picker v-model="period_start" :min-date='new Date()' mode="dateTime" color="purple" is24hr>
                    <template v-slot="{ inputValue, inputEvents }">
                      <input
                        class="form-control text-dark pl-0 bg-white calender-select border-left-0"
                        name="period_start"
                        data-vv-as="Event Date & Time"
                        :value="inputValue"
                        v-on="inputEvents"
                      />
                    </template>
                  </vc-date-picker>
                </b-col>
              </b-row>
              <p
                class="text-danger"
                style="width:100%;margin-top:.25rem;font-size: 80%;"
              >{{ veeErrors.first('period_start') }}</p>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6">
            <b-form-group
              id="input-group-1"
              label-class="control-label"
              label="Location"
              label-for="input-1"
            >
              <input
                id="input-1"
                type="text"
                class="form-control"
                name="location"
                data-vv-as="Location"
                v-model="location"
                placeholder="Location"
              />
              <b-form-invalid-feedback
                id="input-location-feedback"
              >{{ veeErrors.first('location') }}</b-form-invalid-feedback>
            </b-form-group>
          </b-col>
        </b-row>
        <br />
        <b-row class="text-right mt-2">
          <b-col>
            <b-button variant="primary" @click="post()" :disabled="loading" class="mr-5">Create</b-button>
            <router-link :to="{name: 'Event'}">
              <b-button variant="outline-secondary">Cancel</b-button>
            </router-link>
          </b-col>
        </b-row>
        <b-modal v-model="modalShow" title="Preview Image" size="xl">
          <img v-if="url" width height="400px" :src="url" />
        </b-modal>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import summerNote from "@/components/Summernote.vue";

export default {
  components: {
    summerNote
  },
  props: ["totalData"],
  data() {
    return {
      loading: false,
      modalShow: false,
      membership_types: "",
      file: "",
      widthImage: null,
      heightImage: null,
      InputImage: false,
      url: "",
      title_id: "",
      title_en: "",
      content_id: "",
      content_en: "",
      pic_name: "",
      pic_contact: "",
      link_url: "",
      period_start: "",
      period_end: "",
      location: "",
    };
  },
  
  methods: {
    post() {
      this.$validator.validateAll().then(result => {
        if (result) {
          const formData = new FormData();

          formData.append("benefit_type", "paxel_preneur");
          formData.append("titles_en", this.title_en);
          formData.append("titles_id", this.title_id);
          formData.append("contents_en", this.content_en);
          formData.append("contents_id", this.content_id);
          formData.append("pic_name", this.pic_name);
          formData.append("pic_contact", this.pic_contact);
          formData.append("link_url", this.link_url);
          formData.append("location", this.location);

          let date = ""
          let validUntil = ""
          if (this.period_start != "") {
            date = moment(this.period_start).format("YYYY-MM-DDTHH:mm");
            validUntil = moment(this.period_start).format("YYYY-MM-DDTHH:mm");
          }
          formData.append("date", date);
          formData.append("valid_until", validUntil);
          if(this.membership_types == "all_type"){
            formData.append("membership_types", "gold");
            formData.append("membership_types", "silver");
          } else {
            formData.append("membership_types", this.membership_types);
          }
          
          formData.append("image_url", this.file);

          this.loading = true;
          this.$store
            .dispatch("EventModule/postEvent", formData)
            .then(response => {
              this.loading = false;
              this.$router.push({ name: "Event" });
              this.$swal({
                type: "success",
                title: "Your work has been saved",
                showConfirmButton: false,
                timer: 1500
              });
              console.log(response);
            })
            .catch(error => {
              this.loading = false;
              this.serverError = error.response.data;
              this.$swal({
                type: "error",
                title: "Oops...",
                text: error.response.data.message,
                showConfirmButton: false,
                timer: 1500
              });
              console.log(error);
            });
        } else {
          this.$swal({
            type: "error",
            title: "Oops...",
            text: this.$validator.errors.all(),
            showConfirmButton: false,
            timer: 1500
          });
        }
      });
    },
    onChangeFileUpload() {
      this.file = this.$refs.file.files[0];
      const input = this.$refs.file;
      const { files } = input;
      if (files && files[0]) {
        const reader = new FileReader();
        reader.onload = e => {
          const img = new Image();
          img.onload = () => {
            this.widthImage = img.width;
            this.heightImage = img.height;
          };
          img.src = e.target.result;
          this.url = e.target.result;
        };
        reader.readAsDataURL(files[0]);
        this.$emit("input", files[0]);
      }
    },
  }
};
</script>

<style>
</style>
